import React, { useState } from 'react';
import {useTranslation} from 'react-i18next';
import { motion, AnimatePresence } from 'framer-motion';
import { ASSETS_URL } from "../../constants";
import { fadeInUp, staggerContainer, staggerItem, cardHover, modalVariants, floatingIconVariants } from '../../utility/framerMotionAnimations';

const BusinessSection = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    // Functions to handle modal open/close
    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);
    const { t } = useTranslation('homepage');

    const handleRedirect = () => {
        window.open("https://zlite.in/", "_blank");
    };
    const handleInvoiceRedirect = () => {
        window.location.href = "/invoice-gst";
    };
    const handlePayemntRedirect = () => {
        window.location.href = "/payments";
    };

    return (
        <section className='business-section'>
            <div className="section-container">
                <motion.div 
                    className='heading'
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, amount: 0.2, margin: "0px 0px -100px 0px" }}
                    variants={fadeInUp}
                >
                    {t('business-section-heading')}
                </motion.div>
                <motion.div 
                    className='business-frames pd-5'
                    variants={staggerContainer}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, amount: 0.2, margin: "0px 0px -100px 0px" }}
                >
                    <motion.div 
                        className="col-md-3 align-center border-right mobile-border-top"
                        variants={staggerItem}
                        whileHover={cardHover.hover}
                    >
                        <div className="frame-svg">
                            <motion.img 
                                src={`${ASSETS_URL}images/frame-1.svg`} 
                                alt="Loan"
                                variants={floatingIconVariants}
                                animate="animate"
                                style={{ background: 'transparent', backgroundColor: 'transparent' }}
                            />
                        </div>
                        <div className="frame-text">
                            <h3>{t('business-section-feature-title1.line1')}<br/>{t('business-section-feature-title1.line2')}</h3>
                            <p>{t('business-section-feature-description1.line1')}<br/>{t('business-section-feature-description1.line2')}</p>
                        </div>
                        <button className="btn-small btn-primary" onClick={handleInvoiceRedirect}>{t('business-section-feature-button')}</button>
                    </motion.div>
                    <motion.div 
                        className="col-md-3 align-center border-right mobile-border-top"
                        variants={staggerItem}
                        whileHover={cardHover.hover}
                    >
                        <div className="frame-svg">
                            <motion.img 
                                src={`${ASSETS_URL}images/frame-2.svg`} 
                                alt="Loan"
                                variants={floatingIconVariants}
                                animate="animate"
                                style={{ background: 'transparent', backgroundColor: 'transparent' }}
                            />
                        </div>
                        <div className="frame-text">
                        <h3>{t('business-section-feature-title2.line1')}<br/>{t('business-section-feature-title2.line2')}</h3>
                        <p>{t('business-section-feature-description2.line1')}<br/>{t('business-section-feature-description2.line2')}</p>
                        </div>
                        <button className="btn-small btn-primary" onClick={handlePayemntRedirect}>{t('business-section-feature-button')}</button>
                    </motion.div>
                    <motion.div 
                        className="col-md-3 align-center pad-20 mobile-border-top"
                        variants={staggerItem}
                        whileHover={cardHover.hover}
                    >
                        <div className="frame-svg">
                            <motion.img 
                                src={`${ASSETS_URL}images/frame-3.svg`} 
                                alt="Loan"
                                variants={floatingIconVariants}
                                animate="animate"
                                style={{ background: 'transparent', backgroundColor: 'transparent' }}
                            />
                        </div>
                        <div className="frame-text">
                        <h3>{t('business-section-feature-title3.line1')}<br/>{t('business-section-feature-title3.line2')}</h3>
                        <p>{t('business-section-feature-description3.line1')}<br/>{t('business-section-feature-description3.line2')}</p>
                        </div>
                        <button className="btn-small btn-primary" onClick={handleRedirect}>{t('business-section-feature-button')}</button>
                    </motion.div>
                </motion.div>
            </div>
            <AnimatePresence>
                {isModalOpen && (
                    <motion.div 
                        className="modal-overlay" 
                        onClick={closeModal}
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                    >
                        <motion.div 
                            className="modal-content" 
                            onClick={(e) => e.stopPropagation()}
                            variants={modalVariants}
                            initial="hidden"
                            animate="visible"
                            exit="exit"
                        >
                            <h2>Coming Soon</h2>
                            <p>We are working on this feature. Stay tuned!</p>
                            <button className="close-modal-btn" onClick={closeModal}>
                                Close
                            </button>
                        </motion.div>
                    </motion.div>
                )}
            </AnimatePresence>
        </section>
    );
}

export default BusinessSection;